import PropTypes from 'prop-types';
import filter from "ramda/es/filter";
import map from "ramda/es/map";
import propEq from "ramda/es/propEq";
import cx from "ramda-extension/es/cx";
import React from 'react';
import { Toast } from '../Toast';
import toastrPositions from '../toastrPositions';
const Toastr = ({ className, toasts, onClose })=>{
    const renderToast = (toast)=>/*#__PURE__*/ React.createElement(Toast, {
            closeable: toast.closeable,
            onClose: onClose,
            message: toast.message,
            type: toast.type,
            id: toast.id,
            key: toast.id,
            timeout: toast.timeout,
            renderIcon: toast.renderIcon,
            className: toast.options?.className,
            iconMapping: toast.iconMapping,
            title: toast.title,
            titleClassName: toast.titleClassName
        });
    const renderToastsOnPosition = (position)=>/*#__PURE__*/ React.createElement("div", {
            className: cx('Toastr-group', `Toastr-group--position${position}`, className),
            key: `toaster-${position}`
        }, map(renderToast, filter(propEq(position, 'position'), toasts)));
    return /*#__PURE__*/ React.createElement("div", {
        className: cx('Toastr', className)
    }, map(renderToastsOnPosition, toastrPositions.values()));
};
Toastr.propTypes = {
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * This function is called with id of toast id.
	 *
	 * @param {object} Toast object with id
	 * @return {undefined} Nothing
	 */ onClose: PropTypes.func,
    /**
	 * Array of toasts
	 */ toasts: PropTypes.arrayOf(PropTypes.shape({
        message: PropTypes.string,
        position: PropTypes.oneOf(toastrPositions.values()),
        type: PropTypes.string
    }))
};
export default Toastr;
